/** Contact details used by the /flight search results pages */
export const SITE_NAME = 'FlyNodex';
export const PHONE = '1-877-479-3948';
export const PHONE_RAW = '+18774793948';
